<style lang="sass">
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import sass/paragraph
@import sass/link
@import sass/tooltip
</style>

<script>
const TXT_CLASS = 'g_txt_'
const TXT_SIZES = ['XS', 'S', 'M', 'L', 'XL']

export default {
    name: 'paragraph',
    props: {
        content: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'M',
            validator (value) {
                return !!~TXT_SIZES.indexOf(value)
            }
        },
        sizeMobile: {
            type: String,
            validator (value) {
                return !!~TXT_SIZES.indexOf(value)
            }
        }
    },
    render (createElement) {
        let size = this.size
        let children = this.content
        let attributes = {
            domProps: {
                innerHTML: children
            }
        }
        if (children.charAt(0) === '<' && ['p', 'u', 'o'].indexOf(children.charAt(1)) > -1) {
            children = null
        } else {
            children = [createElement('p', attributes)]
            attributes = {}
        }

        if (this.sizeMobile && this.$breakpoint.isS) {
            size = this.sizeMobile
        }

        return createElement('div', {
            ...attributes,
            class: ['g_wysiwyg', TXT_CLASS + size]
        }, children)
    }
}
</script>
